import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DatePrecision } from '@bazis/form/models/form-element.types';
import { BazisInputDateComponent } from '@bazis/form/components/datetime/input-date.component';
import { DateValidators } from '@bazis/form/validators/dateValidators';
import { Modifier, OptionsGeneric } from '@popperjs/core';
import { debounceTime, tap } from 'rxjs';
import { API_DATETIME_FORMAT } from '@bazis/configuration.service';
import { BazisControlValueAccessor } from '@bazis/form/components/control-value-accessor.component';

@Component({
    selector: 'bazis-dropdown-dateinterval',
    templateUrl: './dropdown-dateinterval.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BazisDropdownDateIntervalComponent extends BazisControlValueAccessor {
    @ViewChild('dateFromCpm') dateFromCpm: BazisInputDateComponent;

    @ViewChild('dateToCpm') dateToCpm: BazisInputDateComponent;

    @Input() dateFormat: string = 'YYYY-MM-DD';

    @Input() inputFormat: string = API_DATETIME_FORMAT;

    @Input() precision: DatePrecision = 'days';

    @Input() dateFromTitleKey: string = null;

    @Input() dateToTitleKey: string = null;

    @Input() dateFromPlaceholderKey: string = null;

    @Input() dateToPlaceholderKey: string = null;

    @Input() mode: 'picker' | 'input' = 'picker';

    // настройки popper
    @Input() popperOptions: Partial<OptionsGeneric<Partial<Modifier<any, any>>>> = null;

    @Input() forceDateSelection;

    @Input() placeIcon: 'left' | 'right' = 'right';

    @Output() applied = new EventEmitter();

    disabled = false;

    dateIntervalForm = new FormGroup(
        {
            from: new FormControl(null, [Validators.required]),
            to: new FormControl(null, [Validators.required]),
        },
        DateValidators.intervalDateTwoControlValidatorFn('from', 'to', this.dateFormat),
    );

    valueChanges$ = this.dateIntervalForm.valueChanges.pipe(
        tap((value) => {
            console.log('valueChanges', value);
            this.onChange({ from: value.from, to: value.to });
        }),
    );

    public setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
            this.dateIntervalForm.disable();
        } else {
            this.dateIntervalForm.enable();
        }
    }

    public writeValue(value): void {
        if (value && value.from && value.to) {
            this.dateIntervalForm.setValue(value);
        }
    }

    dateApply() {
        this.applied.emit();
        // console.log('dateApply');
    }
}
